<template lang="pug">
div
  v-card(:loading="busy")

    fluid-action-bar(
      v-bind="$props"
      @refresh="refresh"
      @perform="perform"
    )

  v-row.d-flex.pa-1.mt-1
    fluid-entry.pa-2(
      v-for="(entry,index) in disposition"
      v-bind="$props"
      :pagelet="entry"
      :key="`entry-${index}`"
      @refresh="refresh"
      @perform="perform"
    )

  //- Diálogo de confirmação de operação
  action-dialog(
    v-bind="$props"
    :request="request"
    @actionComplete="refresh()"
    @actionTerminate="request = null"
  )
</template>

<style scoped>
</style>

<script>
import ActionDialog from '@/components/commons/action-dialog/ActionDialog'
import FluidEntry from './FluidEntry'
import FluidActionBar from './FluidActionBar'

export default {
  components: {
    ActionDialog,
    FluidEntry,
    FluidActionBar,
  },

  props: {
    site: String,
    eref: String,
    form: Object,
    data: Object,
    entity: Object,

    busy: Boolean,
  },

  data: () => ({
    /**
     * Registros selecionados na grade.
     * @type {Object}
     *    Format:
     *    {
     *      -- Link da requisição
     *      link: {Keep.Paper.Design.Link}
     *      -- Registros afetados pela requisição.
     *      selection: {Array}
     *    }
     */
    request: null, // Parâmetros de requisição
  }),

  computed: {
    title: vm => vm.entity?.title || vm.entity?.name || vm.entity?.eref,
    description: vm => vm.entity?.description,

    disposition: vm => vm.entity?.disposition || [],

    // autoRefresh: vm => vm.entity?.autoRefresh || 0,
    // hasMoreData: vm => !!vm.set.hasMoreData,
    // hasSelection: vm => !!vm.selection.length,
    // hasActions: vm => !!vm.actions.length,
    // hasDataSetActions: vm => !!vm.dataSetActions.length,
  },

  methods: {
    refresh () {
      this.$emit('refresh')
    },

    perform (opts) {
      // TODO: FIXME: Substituir pelo novo: @/helpers/actions/performAction()
      const link = opts.link
      const rules = opts.link.rule || []
      const browse = rules.some(rule => rule === 'Browse')
      if (browse) {
        this.$go(link)
        } else {
        this.request = opts
      }
    },
  },

  watch: {
    $route () { this.selection = [] },
  },
}
</script>